import React, { useState } from 'react';
import './style.scss';
import SvGBlackBtn from '../SVGBlackCover/button';

let pathName = window.location.host;

if (pathName.includes('localhost')) {
  pathName = 'http://localhost:3000';
} else {
  pathName = 'https://' + pathName;
}

const mobileHeight = 844;
const windowHeight = window.innerHeight;
const ratio = windowHeight / mobileHeight;

const mobileStyle = {
  width: '390px',
  height: mobileHeight + 'px',
  transform: `scale(${ratio})`,
};
const desktopStyle = { width: '100%', height: '100%', transform: 'scale(1)' };

const Embeding = () => {
  const [isMobileStyle, setIsMobileStyle] = useState(false);

  const iframeStyle = isMobileStyle ? { ...mobileStyle } : { ...desktopStyle };

  return (
    <div className="embeding">
      <SvGBlackBtn onClick={() => setIsMobileStyle(!isMobileStyle)} />
      <iframe
        src={pathName}
        style={iframeStyle}
        allowFullScreen
        title="Embedded Content"
      />
    </div>
  );
};

export default Embeding;
